import { render, staticRenderFns } from "./ShapeDataItem.vue?vue&type=template&id=3df06540&scoped=true&"
import script from "./ShapeDataItem.vue?vue&type=script&lang=js&"
export * from "./ShapeDataItem.vue?vue&type=script&lang=js&"
import style0 from "./ShapeDataItem.vue?vue&type=style&index=0&id=3df06540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df06540",
  null
  
)

export default component.exports